import React from 'react';
import { connect } from 'react-redux';
import { formatDate1 } from './../../../../../utils/format';

const OrderRowRequestedDelivDate = props => {
  const { order } = props;
  return (
    <div>
      <div style={{fontSize: '12px', color: '#555'}}>Дата поставки</div>
      <div style={{fontSize: '14px', fontWeight: 'bold'}}>
        {order.requestedDelivDate ? `${formatDate1(order.requestedDelivDate.slice(0,10))}` : ''}
      </div>
    </div>
  );
}

export default connect()(OrderRowRequestedDelivDate);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-preorder/requested-deliv-date.js